import { css, resetButtonStyle } from '@eti/styles';
import { Button, Inline, vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const deckOptionStyles = total => css`
  ${resetButtonStyle};
  border-bottom: 1px solid ${vars.colors.inputs.main};
  display: flex;
  flex-basis: ${`${100 / total}%`};
`;
const DeckSelection = _ref => {
  let {
    onDeckChange,
    options
  } = _ref;
  const handleValueChange = value => () => {
    onDeckChange(value);
  };
  return /*#__PURE__*/_jsx(Inline, {
    "data-testid": "seatMap-deckSelection-dropdown",
    noWrap: true,
    children: options.map((option, index) => /*#__PURE__*/_jsx(Button, {
      className: deckOptionStyles(options.length || 1),
      onClick: handleValueChange(option),
      children: option.label
    }, `deck-option-${index}`))
  });
};
export default DeckSelection;
//# sourceMappingURL=DeckSelection.js.map